import React from 'react';
import { OAuthConfig, OAuthConfigField, OAuthNotice } from 'areas/administration/authentication/types';

export const configFields: OAuthConfigField[] = ['apiKey', 'apiSecret', 'authServer', 'tokenServer', 'scope'];

export const renderText = ({ text, url }: OAuthNotice) => {
	const urlIndex = url ? text.indexOf(url) : -1;
	if (urlIndex == -1) {
		return text;
	}

	return (
		<>
			{text.substring(0, urlIndex)}
			<a href={url} target={'_blank'} rel={'noreferrer'}>
				{url}
			</a>
			{text.substring(urlIndex + url.length)}
		</>
	);
};

export const toConfig = (source: Partial<Record<string, unknown>>): OAuthConfig =>
	Object.fromEntries(
		configFields.map((field) => [field, String((source[field] as string | number) ?? '').trim()]),
	) as OAuthConfig;
